/** Persist the In stock filter across collection and search pages. */
(function () {
  'use strict';

  var STORAGE_KEY = 'tf-instock-filter';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
  var POLL_MS = 100;
  var MAX_WAIT = 15000;
  var RETRY_GAP = 1500;
  var MAX_CLICKS = 4;
  var applyingUntil = 0;
  var clicks = 0;
  var lastClickAt = 0;
  var lastInput = null;
  var startedAt = Date.now();
  var done = false;

  function setPref(on) {
    var val = on ? '1' : '0';
    try {
      localStorage.setItem(STORAGE_KEY, val);
    } catch (e) {}
    document.cookie = STORAGE_KEY + '=' + val + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
  }

  function getPref() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === '1' || stored === '0') return stored;
    } catch (e) {}
    var match = document.cookie.match(/(?:^|;\s*)tf-instock-filter=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function isApplying() {
    return Date.now() < applyingUntil;
  }

  function markApplying() {
    applyingUntil = Date.now() + 1500;
  }

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isInstockLabel(label) {
    var text = normalize(label.textContent);
    return text === 'in stock' || text === 'in stock only' || text.indexOf('in stock') === 0;
  }

  function isVisible(el) {
    return !!(el && (el.offsetParent !== null || el.getClientRects().length));
  }

  function findNostoToggle() {
    var labels = document.querySelectorAll('label.field__switch');
    var fallback = null;
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.closest('#mainCollectionProductFiltersForm, #mainSearchFiltersForm, .product-grid__compare')) {
        continue;
      }
      if (!isInstockLabel(label)) continue;
      var input = label.querySelector('input[type="checkbox"]');
      if (!input || input.disabled) continue;
      if (isVisible(label) || isVisible(input)) return input;
      if (!fallback) fallback = input;
    }
    return fallback;
  }

  function findShopifyToggle() {
    return document.querySelector(
      '#mainCollectionProductFiltersForm input[name*="availability"], #mainSearchFiltersForm input[name*="availability"]'
    );
  }

  function nostoFiltersPresent() {
    return !!document.querySelector('.ns-sidebar-dropdown, [data-nosto-element="facet"], .ns-list-unstyled');
  }

  function isInstockInput(input) {
    if (!input || input.type !== 'checkbox') return false;
    if (input.name && input.name.indexOf('availability') !== -1) return true;
    var label = input.closest('label.field__switch');
    return !!(label && isInstockLabel(label));
  }

  function clickToggle(input) {
    if (!input) return;
    markApplying();
    var label = input.closest('label');
    if (label) label.click();
    else input.click();
  }

  function matchPref(input, pref) {
    return !!input && input.checked === (pref === '1');
  }

  function clickIfNeeded(input, pref) {
    if (matchPref(input, pref)) {
      done = true;
      return true;
    }
    if (clicks >= MAX_CLICKS) {
      done = true;
      return true;
    }
    if (input === lastInput && Date.now() - lastClickAt < RETRY_GAP) return false;
    lastInput = input;
    lastClickAt = Date.now();
    clicks += 1;
    clickToggle(input);
    return false;
  }

  function applyPref() {
    if (done || isApplying()) return false;
    var pref = getPref();
    if (pref !== '1' && pref !== '0') {
      done = true;
      return true;
    }

    var nostoInput = findNostoToggle();
    if (nostoInput) return clickIfNeeded(nostoInput, pref);

    if (nostoFiltersPresent()) return false;

    var shopifyInput = findShopifyToggle();
    if (shopifyInput && !shopifyInput.disabled) return clickIfNeeded(shopifyInput, pref);

    return Date.now() - startedAt > MAX_WAIT;
  }

  function poll() {
    if (done) return;
    if (applyPref() || Date.now() - startedAt > MAX_WAIT) {
      done = true;
      return;
    }
    setTimeout(poll, POLL_MS);
  }

  document.addEventListener(
    'change',
    function (e) {
      if (isApplying()) return;
      if (!isInstockInput(e.target)) return;
      setPref(e.target.checked);
      done = true;
    },
    true
  );

  new MutationObserver(function () {
    if (done || isApplying()) return;
    if (findNostoToggle() || findShopifyToggle()) applyPref();
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();
